/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CopropertyQuestionnaireResponse
 */
export interface CopropertyQuestionnaireResponse {
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyQuestionnaireResponse
     */
    isSuccess?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CopropertyQuestionnaireResponse
     */
    errorMessage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CopropertyQuestionnaireResponse
     */
    isEligible?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CopropertyQuestionnaireResponse
     */
    reasons?: Array<string>;
}

/**
 * Check if a given object implements the CopropertyQuestionnaireResponse interface.
 */
export function instanceOfCopropertyQuestionnaireResponse(value: object): value is CopropertyQuestionnaireResponse {
    return true;
}

export function CopropertyQuestionnaireResponseFromJSON(json: any): CopropertyQuestionnaireResponse {
    return CopropertyQuestionnaireResponseFromJSONTyped(json, false);
}

export function CopropertyQuestionnaireResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyQuestionnaireResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'isSuccess': json['isSuccess'] == null ? undefined : json['isSuccess'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
        'isEligible': json['isEligible'] == null ? undefined : json['isEligible'],
        'reasons': json['reasons'] == null ? undefined : json['reasons'],
    };
}

export function CopropertyQuestionnaireResponseToJSON(json: any): CopropertyQuestionnaireResponse {
    return CopropertyQuestionnaireResponseToJSONTyped(json, false);
}

export function CopropertyQuestionnaireResponseToJSONTyped(value?: CopropertyQuestionnaireResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isSuccess': value['isSuccess'],
        'errorMessage': value['errorMessage'],
        'isEligible': value['isEligible'],
        'reasons': value['reasons'],
    };
}

